function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "icon/local",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.0815457,4.05179882 C9.51968911,4.09227466 7.82879441,5.18814295 7.84364982,7.41219979 C7.85646624,9.33419812 9.21384252,10.6738276 11.0186287,10.7085644 C12.8172979,10.742697 14.2177839,9.09496778 14.2239222,7.4194492 C14.2303091,5.62069075 12.7904999,4.09952407 11.0815457,4.05179882 M11.0314451,21 C10.3268328,20.0992615 9.62658977,19.3365638 9.07577463,18.4714682 C8.19493647,17.0883422 7.29050442,15.719111 6.52181,14.2574498 C5.73185196,12.755917 5.07122334,11.1975971 4.70945052,9.54412879 C4.15601384,7.01469079 4.6765356,4.65893644 6.54365619,2.8891756 C8.44310912,1.0886048 10.953964,0.468780727 13.3203427,1.4948735 C14.9888086,2.2186057 16.1743282,3.38243716 16.9607909,5.02231283 C17.3371278,5.80736291 17.4973332,6.6673235 17.5,7.53997055 C17.5034501,8.73884079 17.3045042,9.90116195 16.9086513,11.0399226 C16.1824842,13.1286572 15.1350324,15.0367608 13.9777672,16.8889836 C13.1085803,18.2802651 12.142979,19.5975423 11.0314451,21",
  id: "Fill-1",
  fill: "#FEFEFE"
}));

function SvgLocal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/local") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocal);
export default __webpack_public_path__ + "static/media/local.79519756.svg";
export { ForwardRef as ReactComponent };